import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { colors, fontFamily, maxWidth } from "./tokens";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

const useStyles = makeStyles(theme => ({
  bar: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 40,
    display: "flex",
    justifyContent: "center",
    background: "rgba(255,255,255,0.75)",
    backdropFilter: "blur(10px)",
    borderBottom: `1px solid transparent`,
    transition: "border-color 0.25s ease, box-shadow 0.25s ease"
  },
  barScrolled: {
    borderBottomColor: colors.border,
    boxShadow: "0 1px 0 rgba(18,21,26,0.02)"
  },
  inner: {
    width: "100%",
    maxWidth,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 3),
    height: 64
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: 9,
    fontFamily,
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: "-0.02em",
    color: colors.ink,
    textDecoration: "none"
  },
  logoMark: {
    height: 26,
    width: "auto",
    display: "block"
  },
  links: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  link: {
    fontFamily,
    fontSize: 14,
    fontWeight: 500,
    color: colors.inkMuted,
    textDecoration: "none",
    transition: "color 0.15s ease",
    "&:hover": {
      color: colors.ink
    }
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2)
  },
  signIn: {
    fontFamily,
    fontSize: 14,
    fontWeight: 500,
    color: colors.ink,
    textDecoration: "none",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  cta: {
    fontFamily,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14,
    borderRadius: 8,
    padding: theme.spacing(1, 2.5),
    backgroundColor: colors.ink,
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      boxShadow: "none"
    }
  }
}));

export default function Navbar() {
  const classes = useStyles();
  const [scrolled, setScrolled] = useState(false);

  const { firstName } = useSelector(
    ({ auth }) => ({ firstName: auth?.user?.user?.firstName || null }),
    shallowEqual
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`${classes.bar} ${scrolled ? classes.barScrolled : ""}`}>
      <nav className={classes.inner}>
        <a href="/" className={classes.logo}>
          <img
            src={toAbsoluteUrl("/media/client-logos/logo.png")}
            alt=""
            className={classes.logoMark}
          />
          ANIKE
        </a>

        <div className={classes.links}>
          <a href="#platform" className={classes.link}>
            Product
          </a>
          <a href="#how-it-works" className={classes.link}>
            How it works
          </a>
          <a href="#capabilities" className={classes.link}>
            Capabilities
          </a>
        </div>

        <div className={classes.actions}>
          {firstName ? (
            <Button className={classes.cta} href="/dashboard">
              Go to dashboard
            </Button>
          ) : (
            <>
              <a href="/auth/login" className={classes.signIn}>
                Sign in
              </a>
              <Button className={classes.cta} href="/auth/registration">
                Get Started
              </Button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
